export default __webpack_public_path__ + "static/media/FontsFree-Net-SFProDisplay-Bold.aa9f6c10.ttf";